import React, { useState, useEffect } from 'react';
import TopBarLogo from '../Shared/TopBarLogo';
import InventarioProducts from '../LoggedIn/InventarioProducts';
import { getDetailedUserInventories } from '../../services/inventoryServices';
import '../../styles/DashboardInventoryUser.css';

export default function UserInventories() {
  const [inventarios, setInventarios] = useState([]);
  const [selectedId, setSelectedId] = useState(''); // ID del inventario seleccionado
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInventarios = async () => {
      try {
        const data = await getDetailedUserInventories();
        setInventarios(data);
        // Si hay al menos uno, preseleccionamos el primero
        if (data.length > 0) {
          setSelectedId(String(data[0].FIInventario));
        }
      } catch (err) {
        console.error("Error al obtener inventarios:", err);
        setError("No se pudieron cargar los inventarios.");
      }
    };
    fetchInventarios();
  }, []);

  // Cuando cambias el <select>, actualiza selectedId
  const handleChange = (e) => {
    setSelectedId(e.target.value);
  };

  // Buscamos el objeto del inventario seleccionado
  const inventarioSeleccionado = inventarios.find(
    (inv) => String(inv.FIInventario) === selectedId
  );

  return (
    <div>
      <div className="info-box">
        <h2 className="card-title">📦 Mi Inventario y Productos</h2>

        {error && <p style={{ color: 'red' }}>{error}</p>}

        {inventarios.length === 0 && !error && (
          <p>No tienes inventarios registrados.</p>
        )}

        {inventarios.length > 0 && (
          <>
            {/* SELECT para elegir inventario */}
            <div className="select-container">
              <label htmlFor="inventario-select">
                Selecciona un inventario:
              </label>
              <select
                id="inventario-select"
                value={selectedId}
                onChange={handleChange}
              >
                {inventarios.map((inv) => (
                  <option
                    key={inv.FIInventario}
                    value={String(inv.FIInventario)}
                  >
                    {inv.FCNombreInventario}
                  </option>
                ))}
              </select>
            </div>

            {inventarioSeleccionado && (
              <div className="inventario-section">
                {/* Datos generales del inventario */}
                <div className="user-card">
                  <div className="card-row">
                    <span className="card-label">📁 Nombre:</span>
                    <span className="card-value">
                      {inventarioSeleccionado.FCNombreInventario}
                    </span>
                  </div>
                  <div className="card-row">
                    <span className="card-label">📅 Creación:</span>
                    <span className="card-value">
                      {inventarioSeleccionado.FDFEchaCreacion
                        ? new Date(inventarioSeleccionado.FDFEchaCreacion).toLocaleDateString()
                        : '—'}
                    </span>
                  </div>
                  <div className="card-row">
                    <span className="card-label">🎖 Rol:</span>
                    <span className="card-value">
                      {inventarioSeleccionado.FCRole || '—'}
                    </span>
                  </div>
                </div>

                {/* Si el rol es “creador”, mostramos el listado de productos */}
                {(
                  (inventarioSeleccionado.FCRole || '').toLowerCase() === 'creador'
                ) && (
                  <div style={{ marginTop: '20px' }}>
                    <InventarioProducts
                      FIInventario={inventarioSeleccionado.FIInventario}
                    />
                  </div>
                )}

                {/* Si no es creador, indicamos que no tiene permiso */}
                {(
                  (inventarioSeleccionado.FCRole || '').toLowerCase() !== 'creador'
                ) && (
                  <p style={{ marginTop: '20px', color: '#555' }}>
                    Solo el creador puede ver los productos de este inventario.
                  </p>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
